import React from 'react';
import { motion } from 'framer-motion';
import { Brain, AlertCircle } from 'lucide-react';
export function ProblemReveal() {
  return <section className="py-20 px-4 bg-brand-plum text-white relative overflow-hidden" data-id="element-207">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-208">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-209">
          <span className="text-4xl mb-4 block" data-id="element-210">💡</span>
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-brand-bg" data-id="element-211">
            La Razón Real Por La Que Todavía No Tienes La Vida Que Deseas
          </h2>
          <p className="text-xl text-brand-gold font-serif italic" data-id="element-212">
            (Y no tiene nada que ver con tu esfuerzo)
          </p>
        </motion.div>

        <div className="space-y-8 text-lg md:text-xl text-brand-bg/90 leading-relaxed" data-id="element-213">
          <p className="text-center" data-id="element-214">
            Seré directa contigo, porque te lo mereces:
          </p>

          <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} className="bg-white/10 backdrop-blur-md p-8 rounded-2xl border border-white/20 text-center relative overflow-hidden" data-id="element-215">
            <Brain className="absolute -right-4 -top-4 w-32 h-32 text-white/5" data-id="element-216" />
            <p className="text-2xl md:text-3xl font-bold text-brand-gold mb-4 relative z-10" data-id="element-217">
              🧠 El 95% de tus pensamientos, decisiones y comportamientos NO los
              controla tu mente consciente.
            </p>
            <p className="relative z-10" data-id="element-218">
              Los controla tu subconsciente — y si está lleno de creencias
              limitantes, te saboteará sin que lo notes.
            </p>
          </motion.div>

          <p data-id="element-219">
            Eso explica por qué puedes querer algo con todas tus fuerzas
            conscientes... y aun así no lograrlo.
          </p>
          <p data-id="element-220">
            Porque hay una parte de ti más profunda que repite, en bucle,
            mensajes como:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-8" data-id="element-221">
            {['No me lo merezco.', 'El dinero siempre escasea.', 'Para mí las cosas no funcionan así.', 'Ya es demasiado tarde.'].map((msg, i) => <div key={i} className="bg-brand-bg/5 p-4 rounded-xl border border-brand-bg/10 flex items-center gap-3" data-id="element-222">
                <AlertCircle className="w-5 h-5 text-brand-rose shrink-0" data-id="element-223" />
                <span className="font-serif italic text-xl" data-id="element-224">"{msg}"</span>
              </div>)}
          </div>

          <p data-id="element-225">
            Y mientras esos mensajes sigan instalados en tu subconsciente,
            ninguna técnica superficial los puede vencer.
          </p>

          <div className="mt-12 p-8 bg-brand-rose/20 rounded-2xl border border-brand-rose/30" data-id="element-226">
            <p className="font-bold text-2xl text-brand-gold mb-4" data-id="element-227">
              Pero aquí viene la buena noticia — y es poderosa:
            </p>
            <p className="mb-4" data-id="element-228">
              La ciencia moderna lo confirma: gracias a la neuroplasticidad, el
              cerebro humano puede cambiar sus patrones a cualquier edad. No es
              magia. Es biología.
            </p>
            <p data-id="element-229">
              Lo que la Abu Aurora descubrió en 35 años es la manera de combinar
              esa capacidad del cerebro con la sabiduría ancestral de la
              manifestación — para que puedas reprogramar desde adentro y
              construir la realidad que siempre supiste que merecías.
            </p>
          </div>
        </div>
      </div>

      <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.65%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22 opacity=%220.05%22/%3E%3C/svg%3E')] opacity-20 mix-blend-overlay pointer-events-none" data-id="element-230"></div>
    </section>;
}